<template>
  <div class="loader-bg" v-if="isLoad">
    <div id='loader'>
		<div id='title' class='flex'>
			<p class='loading-text'>LOADING</p>
		<div class='therefore'>∴</div>
			<p class="loading-number">%</p>
		</div>
		<div id='loading-bar-border'>
			<div class='loading-bar'>
			</div>
		</div>
		<div id='warning'>
			<p style="display: flex;">
				<span class='exclamation'>!</span> Oh.. i can feel my protocols trembling in delight. Keep up the good work, traveler...
			</p>
			<div id='line-cascates'></div>
		</div>
	</div>
  </div>
  <div class="bg">
		<img v-show="lang == 'ru'" class="bg__image" alt="Vue logo" src="./assets/ruBg.png">
		<img v-show="lang == 'en'" class="bg__image" alt="Vue logo" src="./assets/enBg.png">
	</div>

	<img :src="addon" alt="addon" class="addon">

  <div class="lang-btns">
    <button class="lang-btn" @click="setRu" :style="lang == 'en' ? 'cursor: pointer;' : 0">
      <img v-if="lang == 'ru'" class="lang-btn__img" :src="ru2" alt="btn_ru_1">
      <img v-else class="lang-btn__img" :src="ru1" alt="btn_ru_1">
      <img class="lang-btn__img lang-btn__img_active" :src="ru2" alt="btn_ru_2">
    </button>
    <img class="slash" :src="slash" alt="slash">
    <button class="lang-btn" @click="setEn" :style="lang == 'ru' ? 'cursor: pointer;' : 0">
      <img v-if="lang == 'en'" class="lang-btn__img" :src="en2" alt="btn_en_1">
      <img v-else class="lang-btn__img" :src="en1" alt="btn_en_1">
      <img class="lang-btn__img lang-btn__img_active" :src="en2" alt="btn_en_2">
    </button>
  </div>

  <a target="_blank" class="qr qr_top" href="https://t.me/ChatCyberCars">
    <img class="qr__img" :src="qr" alt="qr">
  </a>

  <a target="_blank" class="qr qr_bot" href="https://t.me/ChatCyberCars">
    <img class="qr__img" :src="qr" alt="qr">
  </a>

  <button class="btn btn_top" @click="scrollDown">
    <img v-if="lang == 'ru'" class="btn__img" :src="ruBtn1" alt="btn_1">
    <img v-else class="btn__img" :src="enBtn1" alt="btn_1">
    <img v-if="lang == 'ru'" class="btn__img btn__img_active" :src="ruBtn2" alt="btn_2">
    <img v-else class="btn__img btn__img_active" :src="enBtn2" alt="btn_2">
  </button>

  <button class="btn btn_bot" @click="scrollUp">
    <img v-if="lang == 'ru'" class="btn__img" :src="ruBtn3" alt="btn_3">
    <img v-else class="btn__img" :src="enBtn3" alt="btn_3">
    <img v-if="lang == 'ru'" class="btn__img btn__img_active" :src="ruBtn4" alt="btn_4">
    <img v-else class="btn__img btn__img_active" :src="enBtn4" alt="btn_4">
  </button>
</template>

<script setup>
import ruBtn1 from '@/assets/ruBtn1.svg'
import ruBtn2 from '@/assets/ruBtn2.svg'
import ruBtn3 from '@/assets/ruBtn3.svg'
import ruBtn4 from '@/assets/ruBtn4.svg'

import enBtn1 from '@/assets/enBtn1.svg'
import enBtn2 from '@/assets/enBtn2.svg'
import enBtn3 from '@/assets/enBtn3.svg'
import enBtn4 from '@/assets/enBtn4.svg'

import ru1 from '@/assets/ru1.svg'
import ru2 from '@/assets/ru2.svg'
import en1 from '@/assets/en1.svg'
import en2 from '@/assets/en2.svg'
import qr from '@/assets/qr.svg'
import slash from '@/assets/slash.svg'

import addon from '@/assets/r.svg'


import { onMounted, ref } from 'vue'

const lang = ref('ru');
const isLoad = ref(true)

const setEn = () => {
  console.log(lang.value);
  if (lang.value == 'ru'){
    isLoad.value = true;
    lang.value = 'en'
    unLoad()
  }
}

const setRu = () => {
  console.log(lang.value);
  if (lang.value == 'en'){
    isLoad.value = true
    lang.value = 'ru'
    unLoad()
  }
}

const unLoad = async() => {
  console.log('start');
  setTimeout(() => {
    isLoad.value = false
    console.log('end');
  }, 6000)
}

onMounted(() => {
  setTimeout(unLoad, 1000)
})

import favicon from '@/assets/favicon.png'
import { useFavicon } from '@vueuse/core'

const icon = useFavicon()

icon.value = favicon

const scrollDown = () => {
  document.documentElement.scrollTop = document.documentElement.scrollHeight
}

const scrollUp = () => {
  document.documentElement.scrollTop = 0
}

</script>

<style lang="scss">
@import url(./assets/fonts/Orbitron/stylesheet.css);
@import url(./assets/fonts/venora-font/style.css);

html, body {
	margin: 0;
	padding: 0;
  scroll-behavior: smooth;
  font-family: 'Venora'
}

svg{
  font-family: 'Venora';
}


#app {
  text-align: center;
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
	width: 100%;

	&__image {
		width: 100%;
	}
}

.btn {
  position: absolute;
  width: 8vw;
  padding: 0;
  margin: 0;
  z-index: 100;
  background: none;
  border: none;
  cursor: pointer;

  &_top {
    right: 4vw;
    top: 6vw;
  }

  &_bot {
    right: 4vw;
    top: 265vw;
  }

  &__img {
    width: 8vw;
    position: absolute;
    top: 0;
    left: 0;

    &_active {
      opacity: 0;
      transition: opacity 0.5s ease;


      &:hover {
        opacity: 1;
      }
    }
  }
}

.lang-btns {
  position: absolute;
  z-index: 100;
  left: 4vw;
  top: 5vw;
  display: flex;
  align-items: center;
}

.slash {
  width: 1vw;
  margin: 0 0.5vw;
}

.lang-btn {
  width: 3vw;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  position: relative;

  &:hover {
    .lang-btn__img {
      opacity: 0;
    }

    .lang-btn__img_active {
      opacity: 1;
    }
  }

  &__img {
    width: 3vw;
    opacity: 1;
    transition: opacity 0.5s ease;
    opacity: 1;

    &_active {
      position: absolute;
      z-index: 10002;
      top: 0;
      left: 0;
      opacity: 0;
      transition: opacity 0.5s ease;
    }
  }
}

.qr {
  position: absolute;
  width: 10vw;
  z-index: 100;
  margin: 0;
  padding: 0;

  &__img {
    width: 10vw;
  }

  &_top {
    left: 4vw;
    top: 26vw;
  }

  &_bot {
    right: 4vw;
    top: 245vw;
  }
}

.addon {
  position: absolute;
  width: 30vw;
  top: 122vw;
  left: 12vw;
  z-index: 100000;
}

.loader-bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000000;
}

.loaders {
  display: flex;
}

@property --num {
  syntax: '<integer>';
  initial-value: 0;
  inherits: false;
}

@keyframes initText{
  0% {content:"Initializing system . . ." }
  17% {content:"Initializing system . . . \00000a Loading core modules . . ." }
  27% {content:"Initializing system . . . \00000a Loading core modules . . . \00000a Verifying user permissions . . . " }
  36% {content:"Initializing system . . . \00000a Loading core modules . . . \00000a Verifying user permissions . . . \00000a Compiling source code . . . " }
  42% {content:"Initializing system . . . \00000a Loading core modules . . . \00000a Verifying user permissions . . . \00000a Compiling source code . . . \00000a Running diagnostics . . ." }
  49% {content:"Loading core modules . . . \00000a Verifying user permissions . . . \00000a Compiling source code . . . \00000a Running diagnostics . . . \00000a Establishing secure connection . . ." }
  60% {content:"Verifying user permissions . . . \00000a Compiling source code . . . \00000a Running diagnostics . . . \00000a Establishing secure connection . . . \00000a Scanning for vulnerabilities . . ." }
  66% {content:"Compiling source code . . . \00000a Running diagnostics . . . \00000a Establishing secure connection . . . \00000a Scanning for vulnerabilities . . . \00000a Loading user interface . . . \00000a" }
  78% {content:"Running diagnostics . . . \00000a Establishing secure connection . . . \00000a Scanning for vulnerabilities . . . \00000a Loading user interface . . . \00000a Executing startup procedures . . . \00000a" }
  100% {content:"Establishing secure connection . . . \00000a Scanning for vulnerabilities . . . \00000a Loading user interface . . . \00000a Executing startup procedures . . . \00000a Initializing database connections . . . \00000a"   }
}

@keyframes opcty{
  0% { opacity:0 }
  100% { opacity:1 }
}

@keyframes counting{
    0% { --num: 0 }
    60% { --num: 66 }
    100% { --num: 100 }
}

@keyframes charging {
  0%{ width:0% }
  60%{ width:66% }
  100%{ width:100% }
}

@keyframes rotate{
  0%{
    transform: rotate(0)
  }
  100%{
    transform: rotate(360deg)
  }
}
.flex{
  display:flex;
}

.container{
  display:flex;
  height:100vh;
  flex:1;
  align-items:center;
  justify-content:center;
}

#loader{
  display:flex;
  flex-direction:column;
  width:80%;
  animation: opcty 1s  ease-in-out;
  color: #ffff00;
    
  .loading-text{
    font-family:'Orbitron';
    letter-spacing:0.3rem;
  }
  
  .therefore{
    font-size:24px;
    animation:rotate 1s linear infinite;
    padding-top:9.5px;
    height:fit;
  }
  .loading-number{
    counter-reset: num var(--num);
    margin-left:auto;
    transition: --num 5s;
    animation: counting 3s  ease-in-out;
    font-family:'Orbitron';
    animation-fill-mode: forwards;
    
    &:before{
    font-family:'Orbitron';
    content: counter(num);
    }
  }
}


#loading-bar-border{
  display:flex;
  align-items:center;
  padding:3px;
  border-radius:3px;
  border-top:1px solid #ffff00;
  border-bottom:1px solid #ffff00;
  width:100%;
  
  & .loading-bar{
    height:.6rem;
    margin:1px 0px;
    background:white;
    animation:charging 3s  ease-in-out;
    animation-fill-mode: forwards;
    
  }
}

#warning{
  margin-top:.5rem;
  font-family:'Orbitron';
  display:flex;
  height:1.2rem;
  
  .exclamation{
    width:1rem;
    display:flex;
    justify-content:center;
    background-color:white;
    color: #ffff00;
    border-radius:3px;
  }
}


#line-cascates{
  margin-left:auto;
  display:flex;
  align-items:end;
  margin-top:5rem;
  &:after{
    height:5rem;
    font-size:12px;
    white-space: pre;
    text-align:end;
    color:#ffff00;
    content:"";
    animation: initText 3s ease;
    animation-fill-mode: forwards;
  }
}

@media screen and (max-width: 700px) {
  #line-cascates {
    display: none;
    &:after {
      display: none;
    }
  }
}

</style>
